<template>
  <v-form v-model="form_validate_status" ref="form" :loading="loading">
    <v-card class="mx-auto" max-width="900">
      <v-layout>
        <v-main>
          <v-img height="270" src="images/quest.png" cover>
            <div class="fadebox1"></div>
          </v-img>
          <v-card-text class="text-center">
            <h1 class="mt-0">{{ $t("questionnaire.title") }}</h1>
          </v-card-text>

          <!-- ข้อมูลทั่วไป -->
          <v-card-text class="px-1 px-sm-3 px-xl-6">
            <v-row>
              <v-col>
                <h2 class="text-primary">
                  {{ $t("questionnaire.general_information") }}
                </h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="v-col-12 v-col-md-6">
                <h5>
                  <span class="text-error">*</span>
                  {{ $t("questionnaire.Q0_1") }}
                </h5>
                <v-autocomplete
                  v-model="device"
                  :item-title="(item) => objectTranslator(item, 'name')"
                  :items="device_group"
                  :item-value="(item) => item.device_value"
                  :rules="requiredRules"
                  variant="outlined"
                  density="compact"
                >
                </v-autocomplete>
              </v-col>
              <v-col class="v-col-12 v-col-md-6">
                <h5>
                  <span class="text-error">*</span>
                  {{ $t("questionnaire.Q0_2") }}
                </h5>
                <v-autocomplete
                  v-model="newsSource"
                  :item-title="(item) => objectTranslator(item, 'name')"
                  :items="newsSource_group"
                  :item-value="(item) => item.newsSource_value"
                  :rules="requiredRules"
                  variant="outlined"
                  density="compact"
                >
                </v-autocomplete>
              </v-col>
              <v-col
                class="v-col-12 v-col-md-6"
                v-if="this.newsSource === 'Other'"
              >
                <h5>
                  <span class="text-error">*</span>
                  {{ $t("questionnaire.news_source_specify") }}
                </h5>
                <v-text-field
                  v-model="newsSource_other"
                  :rules="requiredRules"
                  variant="outlined"
                  density="compact"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <!-- ระดับความพึงพอใจ -->
          <v-card-text class="px-1 px-sm-3 px-xl-6">
            <v-row>
              <v-col class="v-col-12 v-col-sm-12">
                <h2 class="text-primary">
                  {{ $t("questionnaire.level_satisfaction_user") }}
                </h2>
                <!-- <v-card-subtitle class="pl-0">{{
                  $t("questionnaire.please_fill_in_truth")
                }}</v-card-subtitle> -->
              </v-col>
            </v-row>
            <v-table>
              <thead>
                <tr>
                  <th class="text-left">
                    <!-- {{ $t("questionnaire.header_table1") }} -->
                  </th>
                  <th class="text-left pa-0" colspan="2">
                    {{ $t("questionnaire.header_table2") }}
                    <!-- <p>{{ $t("questionnaire.header_table2_hint") }}</p> -->
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- ข้อ 1 -->
                <tr>
                  <td colspan="3">{{ $t("questionnaire.Q1") }}</td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q1_1") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q1_1" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q1_1 ? Q1_1 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q1_2") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q1_2" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q1_2 ? Q1_2 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q1_3") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q1_3" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q1_3 ? Q1_3 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q1_4") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q1_4" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q1_4 ? Q1_4 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q1_5") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q1_5" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q1_5 ? Q1_5 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colspan="3">{{ $t("questionnaire.Q2") }}</td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q2_1") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q2_1" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q2_1 ? Q2_1 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q2_2") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q2_2" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q2_2 ? Q2_2 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q2_3") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q2_3" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q2_3 ? Q2_3 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q2_4") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q2_4" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q2_4 ? Q2_4 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q2_5") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q2_5" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q2_5 ? Q2_5 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colspan="3">{{ $t("questionnaire.Q3") }}</td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q3_1") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q3_1" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q3_1 ? Q3_1 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q3_2") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q3_2" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q3_2 ? Q3_2 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q3_3") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q3_3" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q3_3 ? Q3_3 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q3_4") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q3_4" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q3_4 ? Q3_4 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
                <tr>
                  <td style="text-indent: 15px">
                    {{ $t("questionnaire.Q3_5") }}
                  </td>
                  <td>
                    <RatingCard v-model="Q3_5" :rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="text-tag-5">
                      ({{ Q3_5 ? Q3_5 : $t("questionnaire.please_rate") }})
                    </span>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-card-text>

          <v-divider></v-divider>

          <!-- ข้อมูลเพิ่มเติม -->
          <v-card-text class="px-1 px-sm-3 px-xl-6">
            <v-row>
              <v-col class="v-col-12 v-col-sm-12">
                <h2 class="text-primary">
                  {{ $t("questionnaire.additional_info") }}
                </h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="v-col-12 v-col-sm-12" v-if="hasEnoughStar == false">
                <h5>
                  <span class="text-error" v-if="!hasEnoughStar">*</span>
                  {{ $t("questionnaire.additional_1") }}
                </h5>
                <v-textarea
                  v-model="comment_1"
                  class="questionnaire-comment"
                  rows="4"
                  max-rows="10"
                  auto-grow
                  wrap="soft"
                  :rules="requiredRulesTextarea"
                  variant="outlined"
                  density="compact"
                >
                </v-textarea>
              </v-col>
              <v-col class="v-col-12 v-col-sm-12">
                <h5>
                  {{ $t("questionnaire.additional_2") }}
                </h5>
                <v-textarea
                  v-model="comment_2"
                  class="questionnaire-comment"
                  rows="4"
                  max-rows="10"
                  auto-grow
                  wrap="soft"
                  variant="outlined"
                  density="compact"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="d-flex flex-column">
            <v-btn
              variant="flat"
              size="large"
              color="primary"
              :disabled="!form_validate_status"
              @click="saveData"
              >SAVE</v-btn
            >
          </v-card-actions>
        </v-main>
      </v-layout>
    </v-card>
  </v-form>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import RatingCard from "@/components/info_cards/RatingView.vue";
import validator from "@/helper/validator";
import QuestionnaireProvider from "@/services/questionnaire.provider";

const questionnaireService = new QuestionnaireProvider();
export default {
  name: "QuestionView",

  components: { RatingCard },

  data: () => ({
    device_group: [
      {
        device_value: "Android",
        name_TH: "โทรศัพท์มือถือ Android",
        name_EN: "Android System Mobile Phone",
      },
      {
        device_value: "iPhone",
        name_TH: "โทรศัพท์มือถือ iPhone",
        name_EN: "iPhone",
      },
      {
        device_value: "Notebook",
        name_TH: "Notebook (Windows)",
        name_EN: "Notebook (Windows)",
      },
      {
        device_value: "Macbook",
        name_TH: "Macbook (macOS)",
        name_EN: "Macbook (macOS)",
      },
      {
        device_value: "PC",
        name_TH: "คอมพิวเตอร์ตั้งโต๊ะ (PC)",
        name_EN: "Personal Computer (PC)",
      },
      {
        device_value: "iMac",
        name_TH: "iMac",
        name_EN: "iMac",
      },
    ],
    newsSource_group: [
      {
        newsSource_value: "WWW",
        name_TH: "เว็บไซต์สำนักทะเบียนฯ สจล. (www.reg.kmitl.ac.th)",
        name_EN:
          "Website KMITL's office of the Registrar (www.reg.kmitl.ac.th)",
      },
      {
        newsSource_value: "FB:ADMISSION",
        name_TH: "เพจ Facebook: Admission.KMITL",
        name_EN: "Facebook: Admission.KMITL",
      },
      {
        newsSource_value: "FACULTY",
        name_TH: "ประชาสัมพันธ์ของคณะ/วิทยาลัย",
        name_EN: "Public Relations from Faculty / College ",
      },
      {
        newsSource_value: "Other",
        name_TH: "อื่นๆ",
        name_EN: "Other",
      },
    ],

    loading: false,
    form_validate_status: null,

    device: null,
    newsSource: null,
    newsSource_other: null,

    Q1_1: null,
    Q1_2: null,
    Q1_3: null,
    Q1_4: null,
    Q1_5: null,

    Q2_1: null,
    Q2_2: null,
    Q2_3: null,
    Q2_4: null,
    Q2_5: null,

    Q3_1: null,
    Q3_2: null,
    Q3_3: null,
    Q3_4: null,
    Q3_5: null,

    comment_1: null,
    comment_2: null,

    requiredRules: [validator.required],
    // intGratterZeroRules: [validator.int_gratter_zero],
    requiredRulesTextarea: [validator.required, validator.minChar(50)],
  }),

  methods: {
    objectTranslator,
    async fetch_data() {
      this.loading = true;
      const data = await questionnaireService
        .getQuestionnaire(this.uid)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });

      this.device = data.DEVICE;
      this.newsSource = data.NEWS;
      this.newsSource_other = data.NEWS_OTHER;

      this.Q1_1 = parseInt(data.Q1_1);
      this.Q1_2 = parseInt(data.Q1_2);
      this.Q1_3 = parseInt(data.Q1_3);
      this.Q1_4 = parseInt(data.Q1_4);
      this.Q1_5 = parseInt(data.Q1_5);

      this.Q2_1 = parseInt(data.Q2_1);
      this.Q2_2 = parseInt(data.Q2_2);
      this.Q2_3 = parseInt(data.Q2_3);
      this.Q2_4 = parseInt(data.Q2_4);
      this.Q2_5 = parseInt(data.Q2_5);

      this.Q3_1 = parseInt(data.Q3_1);
      this.Q3_2 = parseInt(data.Q3_2);
      this.Q3_3 = parseInt(data.Q3_3);
      this.Q3_4 = parseInt(data.Q3_4);
      this.Q3_5 = parseInt(data.Q3_5);

      this.comment_1 = data.COMMENT_1;
      this.comment_2 = data.COMMENT_2;

      this.loading = false;
    },

    async saveData() {
      this.loading = true;
      const response = await questionnaireService
        .setQuestionnaire({
          uid: this.uid,
          DEVICE: this.device,
          NEWS: this.newsSource,
          NEWS_OTHER: this.newsSource === "Other" ? this.newsSource_other : "",

          Q1_1: this.Q1_1,
          Q1_2: this.Q1_2,
          Q1_3: this.Q1_3,
          Q1_4: this.Q1_4,
          Q1_5: this.Q1_5,

          Q2_1: this.Q2_1,
          Q2_2: this.Q2_2,
          Q2_3: this.Q2_3,
          Q2_4: this.Q2_4,
          Q2_5: this.Q2_5,

          Q3_1: this.Q3_1,
          Q3_2: this.Q3_2,
          Q3_3: this.Q3_3,
          Q3_4: this.Q3_4,
          Q3_5: this.Q3_5,

          COMMENT_1: this.comment_1,
          COMMENT_2: this.comment_2,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (response && response.status) {
        this.$toast.success(this.$t("toast.save_successfully"));
      } else this.$toast.error(this.$t("toast.cannot_save"));
      this.loading = false;
    },
  },

  computed: {
    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },

    hasEnoughStar() {
      let data = false;
      if (
        parseInt(this.Q1_1) +
          parseInt(this.Q1_2) +
          parseInt(this.Q1_3) +
          parseInt(this.Q1_4) +
          parseInt(this.Q1_5) +
          parseInt(this.Q2_1) +
          parseInt(this.Q2_2) +
          parseInt(this.Q2_3) +
          parseInt(this.Q2_4) +
          parseInt(this.Q2_5) +
          parseInt(this.Q3_1) +
          parseInt(this.Q3_2) +
          parseInt(this.Q3_3) +
          parseInt(this.Q3_4) +
          parseInt(this.Q3_5) >=
        45
      ) {
        data = true;
      }

      return data;
    },
  },

  watch: {},

  created() {
    this.fetch_data();
  },
};
</script>

<style scoped>
.questionnaire-comment :deep(textarea) {
  overflow-wrap: anywhere;
}

.fadebox1 {
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, #fffffff8);
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 25%;
}

td {
  padding: 0px !important;
}
</style>
